import * as React from "react";

function Docs(props) {
  return (
    <svg
      width={26}
      height={26}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.26 3.25h10.028l5.379 4.951v12.776c0 .98-.863 1.773-1.926 1.773H6.259c-1.063 0-1.926-.794-1.926-1.773V5.023c0-.98.863-1.773 1.926-1.773zm7.703 1.773H6.259v15.954h13.482V10.341h-3.852c-1.064 0-1.926-.794-1.926-1.773V5.023zm1.926.367v3.178h3.453L15.889 5.39zm-6.74 12.042v-1.773h5.777v1.773H9.148zm0-5.318v1.772h7.703v-1.772H9.148z"
      />
    </svg>
  );
}

export default Docs;
